export const projectOperationsList = {
  newProject: "NEW_PROJECT",
  updateProject: "UPDATE_PROJECT",
  listProject: "LIST_PROJECT",
  previewProject: "PREVIEW_PROJECT",
  projectTask: "PROJECT_TASK",
};

export const PROJECT_STATUS = {
  ENQUIRY: "Enquiry",
  MOCK_UP_REQUIRED: "Mock-Up",
  REGISTER_PROJECT: "Register",
};
